import { ChevronDown, ChevronRight, PlusCircle, X, Download, FileText } from 'react-feather';

const OrderNotesSection = ({
	sections,
	toggleSection,
	formRef,
	onSubmitFile,
	handleSubmit,
	register,
	errors,
	fileInputs,
	fileUploadHandler,
	removeFileInput,
	addFileInput,
	Msg,
	progress,
	orderDetails,
	getUserName,
    onViewAttachment,
}) => {
	return (
		<div className="tab-information">
			<div className="title-block" onClick={() => toggleSection('notes')}>
				<h2 className="title-h2">Order Notes</h2>
				<button>
					{sections.notes ? (
						<ChevronDown size={24} />
					) : (
						<ChevronRight size={24} />
					)}
				</button>
			</div>
			{sections.notes && (
				<div className="content-block p-4">
					{/* New Note Form */}
					<div className="bg-white rounded-lg mb-6">
						<form ref={formRef} onSubmit={handleSubmit(onSubmitFile)}>
							<div className="mb-3">
								<textarea
									placeholder="Type your note here..."
									className="w-full p-3 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 min-h-[100px] text-sm"
									{...register('textNote', { required: true })}
								/>
								{errors.textNote && (
									<span className="text-red-500 text-xs mt-1 block">This field is required</span>
								)}
							</div>

							<div className="space-y-2 mb-4">
								{fileInputs.map((index, i) => (
									<div key={`${index}-${i}`} className="flex items-center gap-2">
										<input
											type="file"
											name="file"
											className="block w-full text-sm text-slate-500
                                                file:mr-4 file:py-2 file:px-4
                                                file:rounded-full file:border-0
                                                file:text-sm file:font-semibold
                                                file:bg-blue-50 file:text-blue-700
                                                hover:file:bg-blue-100 cursor-pointer"
											onChange={(e) => {
												if (e.target.files.length > 0) {
													fileUploadHandler(e.target.files[0]);
												}
											}}
										/>
									</div>
								))}
							</div>

                            <div className="flex items-center justify-between">
								<div className="flex gap-2">
									<button 
                                        type="button" 
                                        onClick={addFileInput}
                                        className="flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800"
                                    >
										<PlusCircle size={16} />
                                        <span>Add File</span>
									</button>
                                    {fileInputs.length > 1 && (
                                        <button 
                                            type="button" 
                                            onClick={removeFileInput}
                                            className="flex items-center gap-1 text-sm text-red-500 hover:text-red-700"
                                        >
                                            <X size={16} />
                                            <span>Remove</span>
                                        </button>
                                    )}
								</div>

                                <button
                                    type="submit"
                                    className="px-6 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 transition-colors shadow-sm"
                                >
                                    Save Note
                                </button>
                            </div>

							{Msg && (
								<div className="mt-2 text-green-600 text-sm font-medium">
									{Msg}
								</div>
							)}
							{progress.started && (
								<div className="w-full bg-gray-200 rounded-full h-2.5 mt-2">
									<div
										className="bg-blue-600 h-2.5 rounded-full"
										style={{ width: `${progress.pc}%` }}
									></div>
                                    <span className="text-xs text-gray-500 mt-1 block">{progress.msg}</span>
								</div>
							)}
						</form>
					</div>

                    <div className="border-t border-slate-200 my-6"></div>

					{/* Notes List */}
					<div className="space-y-4">
                        <h3 className="text-sm font-bold text-slate-700 uppercase tracking-wide mb-3">Previous Notes</h3>
						{orderDetails?.notes && orderDetails.notes.length > 0 ? (
							[...orderDetails.notes].reverse().map((note, index) => (
								<div key={index} className="bg-slate-50 border border-slate-200 rounded-lg p-4 shadow-sm relative group hover:bg-slate-100 transition-colors">
									<div className="flex justify-between items-start mb-2">
                                        <div className="flex items-center gap-2">
                                            <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold text-xs uppercase">
                                                {note?.userId ? getUserName(note?.userId).charAt(0) : 'U'}
                                            </div>
                                            <div>
                                                <p className="text-sm font-semibold text-slate-900">
                                                    {note?.userId ? getUserName(note?.userId) : 'Unknown User'}
                                                </p>
                                                {/* Optional: Add role here if available */}
                                            </div>
                                        </div>
										<span className="text-xs text-slate-500 whitespace-nowrap">
											{new Date(note?.createdAt).toLocaleString('en-US', {
												month: 'short',
												day: 'numeric',
												year: 'numeric',
												hour: 'numeric',
												minute: '2-digit',
											})}
										</span>
									</div>
									
									<div className="text-sm text-slate-700 whitespace-pre-wrap pl-10">
										{note?.text}
									</div>

									{note?.attachments?.length > 0 && (
										<div className="mt-3 pl-10 flex flex-wrap gap-2">
											{note.attachments.map((file, i) => (
												<button
													key={i}
													type="button"
													onClick={(e) => {
														e.preventDefault();
                                                        if (onViewAttachment) {
                                                            onViewAttachment({
                                                                url: file.url,
                                                                name: file.description || `Attachment ${i + 1}`,
                                                                type: file.type
                                                            });
                                                        } else {
                                                            window.open(file.url, '_blank', 'noopener,noreferrer');
                                                        }
													}}
													className="flex items-center gap-2 px-3 py-1.5 bg-white border border-slate-300 rounded text-xs text-slate-600 hover:text-blue-600 hover:border-blue-400 transition-colors shadow-sm"
                                                    title={file.description || "View Attachment"}
												>
													<FileText size={14} />
													<span className="truncate max-w-[150px]">{file.description || `Attachment ${i + 1}`}</span>
												</button>
											))}
										</div>
									)}
								</div>
							))
                        ) : (
                            <p className="text-slate-400 text-sm text-center py-4 italic">No notes added yet.</p>
                        )}
					</div>
				</div>
			)}
		</div>
	);
};

export default OrderNotesSection;
